export default __webpack_public_path__ + "static/media/Miscellaneous04.e03de099.jpg";